<form class="card mt-2">
  <div class="card-body">
    <div class="float-right">
      <button type="button" routerLink="/uploaddocs/approval-list" class="btn btn-secondary mr-2">
        Upload Approval
        <span *ngIf="uploadDocApprovalCount>0" class="badge badge-danger">{{uploadDocApprovalCount}}</span>
      </button>
      <button type="button" routerLink="/queues/hr-employee-changes" class="btn btn-secondary mr-2">
        Employee Changes
        <span *ngIf="hrEmployeeChangeCount>0" class="badge badge-danger">{{hrEmployeeChangeCount}}</span>
      </button>
      <button *ngIf="canManage" type="button" routerLink="/uploaddocs/vaccine-list" class="btn btn-secondary">Uploaded Vaccine Information</button>      
    </div>
    <h2 class="mb-3">Form Approval</h2>
    <div class="mb-3">

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Campus:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!campusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="campusList" [(ngModel)]="campusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Form:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!formList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="formList" [(ngModel)]="formId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>      

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Employee:</h5>
        </div>
        <div class="col-10">
          <div class="ml-2 w-100 mb-2">
            <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="reloadListAfterStaffChange($event)" [forceSelection]="true"
                            (onClear)="reloadListAfterClear($event)"></p-autoComplete>
          </div>
        </div>
      </div>                      

    </div>

    <i [hidden]="!loadingList && !loadingDoc" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="175px"></th>
          <th [pSortableColumn]="'EmployeeName'">Employee <p-sortIcon [field]="'EmployeeName'"></p-sortIcon></th>
          <th [pSortableColumn]="'PrimaryProgram'">Primary Campus <p-sortIcon [field]="'PrimaryProgram'"></p-sortIcon></th>
          <th [pSortableColumn]="'FormName'">Form<p-sortIcon [field]="'FormName'"></p-sortIcon></th>         
          <th [pSortableColumn]="'SignedDate'">Date Signed<p-sortIcon [field]="'SignedDate'"></p-sortIcon></th>
          <th width="150px">Dismiss</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-list>
        <tr>
          <td>
            <span style="font-size: 20px;" class="pointer mr-2" (click)="downloadForm(list)"><i title="Download signed Form Submission" class="fas fa-file-download"></i></span>
            <span style="font-size: 20px;" class="pointer mr-2" (click)="seeFormResult(list)"><i title="See Form Information" class="fab fa-wpforms"></i></span>
            <span style="font-size: 20px;" class="pointer mr-2" (click)="editUser(list)"><i title="Edit User" class="far fa-user-edit"></i></span>            
          </td>
          <td>
            <span class="ui-column-title">Employee</span>
            {{list.firstName}} {{list.lastName}} <span style="font-style:italic; color: red; font: 0.9rem;">{{getTerminationString(list)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Primary Campus</span>
            {{list.primaryProgram}}
          </td>
          <td>
            <span class="ui-column-title">Form</span>
            {{list.formName}}
          </td>         
          <td>
            <span class="ui-column-title">Date Signed</span>
            {{list.signedDate | date: 'MM/dd/yyyy @ hh:mm:ss a'}}
          </td>
          <td>
            <span class="pointer mr-2 btn-link" (click)="approveForm(list)">Dismiss</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</form>
